export function normalizeTxMethod(method: string | null | undefined): string | null | undefined {
  if (!method) {
    return method;
  }

  const m = method.trim().toLowerCase();

  if (m === '0x78343032' || m === '78343032') {
    return 'X402';
  }

  return method;
}
